import { Button } from 'antd';
import styled from 'styled-components';
import { common, group, shape, size, variant } from './styles';

interface BaseButtonProps {
  size?: string;
  variant?: string;
  group?: string;
  shape?: string;
  type?: string;
}

// `&&` bumps specificity so these styles win over antd's base regardless of CSS load order.
const BaseButton = styled(Button)<BaseButtonProps>`
  && {
    ${(props) => size[props.size]};
    ${(props) => variant[props.variant]};
    ${(props) => group[props.group]};
    ${(props) => shape[props.shape]};

    ${common};
  }
`;

export default BaseButton;
